<template>
  <wo-region v-if="showList">
    <wo-layout>
      <wo-title tag-name="h3" v-t="'admin.users.title'"></wo-title>
      <wo-grid>
        <wo-column width-md="6">
          <po-input-field v-model="searchText" v-focus="true" name="searchText" label-key="general.searchText" :debounce="true" />
        </wo-column>
        <wo-column width-md="3">
          <wo-label v-t="'general.status'" for="status"></wo-label>
          <po-selector v-model="selectedStatus" :options="statuses" :required="true" />
        </wo-column>
      </wo-grid>
    </wo-layout>
    <wo-spacer />
    <wo-layout>
      <user-list :filter="filter">
        <po-route-link :value="createRoute" slot="actions"></po-route-link>
      </user-list>
    </wo-layout>
  </wo-region>
  <router-view v-else />
</template>

<script>

import _ from 'lodash'
import { mapState } from 'vuex'

import { ADMIN_USERS, ADMIN_USER_CREATE } from '@/routes/admin'

import UserList from '@/components/admin/UserList'
import { UserStatusEnum } from '@/model/identity'

const ANY_STATUS = { labelKey: 'general.any' }

export default {
  components: { UserList },
  data () {
    return {
      searchText: undefined,
      selectedStatus: ANY_STATUS
    }
  },
  computed: mapState({
    statuses () {
      return _.map(UserStatusEnum.values, s => s).concat(ANY_STATUS)
    },
    showList () {
      return this.$route.name === ADMIN_USERS
    },
    createRoute () {
      return ADMIN_USER_CREATE
    },
    filter () {
      return {
        search_text: this.searchText,
        status: this.selectedStatus && this.selectedStatus.id
      }
    }
  })
}
</script>
